import { isFixedViewportRoute } from "./fixedViewportRoute";
import { SIDE_MENU_RAIL_MAX_WIDTH_PX } from "./components/SegmentBuilder/Main/WheelLayout/styles";

// ISP-9999 (hw-0914-dev-embed-url-toast-covers-save-chip) — MEASURED on
// web-dev.iyuga.net/builder/6332 (main.af840613.js): react-toastify's
// top-right toast sits `1em` from the top of the viewport by default, which
// lands directly on top of WheelHeader's AutosaveChip and account avatar —
// 75%+ of the chip's area covered while the toast is up, so the user can't
// tell whether their work saved. /builder/:id and /wheel/:wheelId are the
// two routes where that header row occupies a fixed on-screen position for
// as long as the page is open (see fixedViewportRoute.js, same route set as
// the white-bar-across-bottom fix) — everywhere else a toast at the top
// doesn't sit over anything, so only those two routes get pushed down.
export const TOAST_CLEARANCE_BELOW_HEADER = "calc(max(60px, 8vh) + 12px)";

// ONLY matches /builder/:id, NOT /wheel/:wheelId (ViewWheel) — the rail
// (SideMenu) and the Wheel Settings panel it opens are builder-only chrome.
const BUILDER_RAIL_ROUTE_RE = /^\/builder(\/|$)/;

// stgfix-1008-B22 — MEASURED live on web-stg.iyuga.net/builder/507568
// (main.e3974551.js): TOAST_CLEARANCE_BELOW_HEADER alone only clears
// WheelHeader's row. It does NOT clear SideMenu's icon rail
// (x:[1440-SIDE_MENU_RAIL_MAX_WIDTH_PX, 1440]), which is fixed for the
// builder's entire height, not just the header row — a top-right toast at
// the default 1em-from-right offset landed squarely on the rail's "Wheel"
// icon, hiding it completely. Push the toast left past the rail's own
// width (plus the default 1em margin react-toastify would otherwise use).
export const TOAST_CLEARANCE_FROM_RIGHT_RAIL = `calc(${SIDE_MENU_RAIL_MAX_WIDTH_PX}px + 1em)`;

// Same measurement: with the Wheel Settings panel open, its Info/Design/
// Access tab row sits directly beneath WheelHeader (y:[157,205] at 1440x900)
// — close enough beneath it that TOAST_CLEARANCE_BELOW_HEADER's plain
// header-clearance still left the toast's bottom edge clipping the tab
// row's top ~7px. Reserve extra clearance on top of the header offset so
// the toast clears the tab row too, whichever of the panel's tabs is open.
export const TOAST_CLEARANCE_BELOW_BUILDER_PANEL = `calc(${TOAST_CLEARANCE_BELOW_HEADER} + 130px)`;

export function resolveToastContainerStyle(pathname) {
  const base = { zIndex: 999999999 };
  if (!isFixedViewportRoute(pathname)) return base;
  if (BUILDER_RAIL_ROUTE_RE.test(pathname)) {
    return {
      ...base,
      top: TOAST_CLEARANCE_BELOW_BUILDER_PANEL,
      right: TOAST_CLEARANCE_FROM_RIGHT_RAIL,
    };
  }
  return { ...base, top: TOAST_CLEARANCE_BELOW_HEADER };
}

// T22.636 — MEASURED live on web-stg.iyuga.net/wheel/510012 (main.b86c7763.js,
// 384x740 phone, verified viewer, Gordon's S23+ path): with a Segment open the
// phone header slides away (MobileView Styled.Header hideView, -18svh), the
// title bar moves to y:0 and the creator's profile card follows at y:72. The
// /wheel/:wheelId clearance above (TOAST_CLEARANCE_BELOW_HEADER, 72px here)
// then drops "You are now following kelly." at y:[72,136], covering the card's
// avatar, name and the Follow button just tapped (64px, 46% of the card).
// That clearance exists for a header row that is fixed on screen; on the phone
// View Wheel the header is not fixed, so the toast goes back to the top edge
// (over the header / title bar slot), see styles/toastViewWheelPhone.css. A
// class (not inline style) because only a media query knows the viewport is a
// phone; desktop /wheel/:wheelId keeps the inline header clearance.
export const VIEW_WHEEL_TOAST_CLASS = "iyuga-toast--view-wheel";

const VIEW_WHEEL_ROUTE_RE = /^\/wheel\/[^/]+\/?$/;

export function resolveToastContainerClassName(pathname) {
  return VIEW_WHEEL_ROUTE_RE.test(pathname) ? VIEW_WHEEL_TOAST_CLASS : undefined;
}
